import PageHeader from "@/components/pageHeader";
import { Send, MapPin, Phone, Mail, Clock } from "lucide-react";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const ContactPage = () => {
  const navigate = useNavigate();

  const [sending, setSending] = useState(false);
  const [utmSource, setUtmSource] = useState("google");
  const [formError,setFormError] = useState({});
 const [mailURL ,setMailURL]=useState("");
  const [submitted, setSubmitted] = useState(false);

  const currentDate = new Date()
    .toLocaleDateString("en-GB")
    .replace(/-/g, "/");

    const [data, setData] = useState({
    name: "",
    message: "",
    email: "",
    mobile: "",
    date: currentDate,
    ipAddress: "",
    subject: "Query",
    leadSource: "google",
    project: "",
});
const location = useLocation();

  useEffect(() => {
    if (location.hash === "#contact-map") {
      setTimeout(() => {
        const element = document.getElementById("contact-map");

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 300);
    }
  }, [location]);

 

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const utm_source =
      urlParams.get("utm_source") || "google";

    setUtmSource(utm_source);

    setData((prev) => ({
      ...prev,
      leadSource: utm_source,
    }));
  }, []);

  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((ipData) => {
        setData((prev) => ({
          ...prev,
          ipAddress: ipData.ip,
        }));
      })
      .catch(() => {
        console.log("Failed to fetch IP");
      });
  }, []);

  const validate = (values) => {
    const errors = {};

    if (!values.name)
      errors.name = "Name is required";

    if (!values.email) {
      errors.email = "Email is required";
    } else {
      const emailRegex =
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

      if (!emailRegex.test(values.email)) {
        errors.email = "Invalid Email";
      }
    }

    if (!values.mobile) {
      errors.mobile = "Phone is required";
    }

    return errors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setData((prev) => ({
      ...prev,
      [name]: value,
      leadSource: utmSource,
    }));
  };
  useEffect(() => {
const endpoint = process.env.REACT_APP_ENDPOINT_MAIL_URL;

const fullURL = `${window.location.origin}${endpoint}${
process.env.REACT_APP_SEND_MAIL_TOKEN
? `${endpoint.includes("?") ? "&" : "?"}token=${encodeURIComponent(
process.env.REACT_APP_SEND_MAIL_TOKEN)}`
: ""
}`;setMailURL(fullURL);
}, []);

 const sendMail = async (e) => {
  e.preventDefault();

  if (!mailURL) return;

  const errors = validate(data);
  setFormError(errors);

  if (Object.keys(errors).length > 0) return;

  try {
   

    const response = await fetch(mailURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error("Request failed");
    }

    setSubmitted(true);

    setData({
      name: "",
      message: "",
      email: "",
      mobile: "",
      date: currentDate,
      ipAddress: "",
      subject: "Query",
      leadSource: utmSource,
      project: "",
    });

    setTimeout(() => {
      navigate("/thankyou");
    }, 1000);
  } catch (error) {
    alert("Something went wrong. Please try again.");
  } 
};

  return (
    <div data-testid="v13-contact-page">
      <PageHeader title="Contact Us" subtitle="Get In Touch" backgroundImage="https://images.unsplash.com/photo-1497366216548-37526070297c?w=1920" />
      <section className="py-20 lg:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-2 gap-16">
            <div>
              <span className="font-body text-xs tracking-[0.2em] uppercase text-[#C4A265] mb-4 block">Reach Out</span>
              <h2 className="text-3xl sm:text-4xl text-[#0A0A0A] mb-6" style={{ fontFamily: "'Cormorant Garamond', serif" }}>We'd Love to Hear From You</h2>
              <div className="w-16 h-0.5 bg-[#C4A265] mb-8" />
              <p className="font-body text-base text-[#4A4A4A] leading-relaxed mb-12">Whether you're looking for your dream home, a commercial space, or have questions about our projects, our team is here to help.</p>
              <div className="space-y-8">
                <div className="flex items-start gap-4"><div className="w-12 h-12 bg-[#C4A265]/10 flex items-center justify-center flex-shrink-0"><MapPin className="text-[#C4A265]" size={20} /></div><div><h4 className="font-body font-medium text-[#0A0A0A] mb-2">Head Office</h4><p className="font-body text-[#4A4A4A]">SCO 53-54, Sector-127, Gillco Valley,<br />Chandigarh-Kharar Highway,<br />Mohali, Punjab - 140301</p></div></div>
                <div className="flex items-start gap-4"><div className="w-12 h-12 bg-[#C4A265]/10 flex items-center justify-center flex-shrink-0"><Phone className="text-[#C4A265]" size={20} /></div><div><h4 className="font-body font-medium text-[#0A0A0A] mb-2">Phone</h4><a href="tel:+917529079797" className="font-body text-[#C4A265] hover:underline">+91 75290 79797</a></div></div>
                <div className="flex items-start gap-4"><div className="w-12 h-12 bg-[#C4A265]/10 flex items-center justify-center flex-shrink-0"><Mail className="text-[#C4A265]" size={20} /></div><div><h4 className="font-body font-medium text-[#0A0A0A] mb-2">Email</h4><a href="mailto:helpdesk@gillcogroup.com" className="font-body text-[#C4A265] hover:underline">helpdesk@gillcogroup.com</a></div></div>
                <div className="flex items-start gap-4"><div className="w-12 h-12 bg-[#C4A265]/10 flex items-center justify-center flex-shrink-0"><Clock className="text-[#C4A265]" size={20} /></div><div><h4 className="font-body font-medium text-[#0A0A0A] mb-2">Business Hours</h4><p className="font-body text-[#4A4A4A]">Monday - Saturday: 9:00 AM - 6:00 PM<br />Sunday: By Appointment</p></div></div>
              </div>
            </div>
            <div className="bg-[#FAFAFA] p-8 lg:p-12">
              <h3 className="text-2xl text-[#0A0A0A] mb-8" style={{ fontFamily: "'Cormorant Garamond', serif" }}>Send Us a Message</h3>

              <form onSubmit={sendMail} className="space-y-6" data-testid="v13-contact-form">
                <div><label className="font-body text-sm text-[#4A4A4A] uppercase tracking-wider block mb-2">Full Name *</label><>
                  <input
                    type="text"
                    name="name"
                    value={data.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-white border border-[rgba(0,0,0,0.1)] focus:border-[#C4A265] focus:outline-none font-body"
                  />

                  {formError.name && (
                    <p className="text-red-500 text-xs mt-1">
                      {formError.name}
                    </p>
                  )}
                </></div>


                <div className="grid sm:grid-cols-2 gap-6">
                  <div>
                    <label className="font-body text-sm text-[#4A4A4A] uppercase tracking-wider block mb-2">
                      Email *
                    </label>

                    <input
                      type="email"
                      name="email"
                      value={data.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 bg-white border border-[rgba(0,0,0,0.1)] focus:border-[#C4A265] focus:outline-none font-body"
                    />

                    {formError.email && (
                      <p className="text-red-500 text-xs mt-1">
                        {formError.email}
                      </p>
                    )}
                  </div>

                  <div>
                    <label className="font-body text-sm text-[#4A4A4A] uppercase tracking-wider block mb-2">
                      Phone *
                    </label>

                    <input
                      type="tel"
                      name="mobile"
                      value={data.mobile}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 bg-white border border-[rgba(0,0,0,0.1)] focus:border-[#C4A265] focus:outline-none font-body"
                    />

                    {formError.mobile&& (
                      <p className="text-red-500 text-xs mt-1">
                        {formError.mobile}
                      </p>
                    )}
                  </div>
                </div>



                <div><label className="font-body text-sm text-[#4A4A4A] uppercase tracking-wider block mb-2">Interested Project</label><select name="project" value={data.project} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-[rgba(0,0,0,0.1)] focus:border-[#C4A265] focus:outline-none font-body"><option value="">Select a Project</option><option>Gillco Meraqui</option><option>Gillco Parkhills</option><option>Gillco Palms</option><option>Gillco Villas</option><option>Gillco Floors</option><option>Gillco Towers</option><option>Gillco Heights</option><option>Gillco Industrial Park</option><option>Other</option></select></div>
                <div><label className="font-body text-sm text-[#4A4A4A] uppercase tracking-wider block mb-2">Message</label><textarea name="message" value={data.message} onChange={handleChange} rows={4} className="w-full px-4 py-3 bg-white border border-[rgba(0,0,0,0.1)] focus:border-[#C4A265] focus:outline-none font-body resize-none" /></div>
                <button
                  type="submit"
                  disabled={sending}
                  className="w-full inline-flex items-center justify-center gap-3 bg-[#0A4F3B] text-white px-8 py-4 text-sm tracking-[0.1em] uppercase hover:bg-[#1A6F53] transition-colors disabled:opacity-50"
                >
                  {sending ? "Sending..." : "Send Message"}
                  <Send size={16} />
                </button>
              </form>

            </div>
          </div>
        </div >
      </section >
      <section id="contact-map" className="h-[400px] bg-[#FAFAFA]"><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3429.146907052943!2d76.6570703!3d30.7423747!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390fef58b22a65dd%3A0x7796aaf1a413402d!2sGillco%20Group!5e0!3m2!1sen!2sin!4v1780648691309!5m2!1sen!2sin" width="100%" height="100%" style={{ border: 0 }} allowFullScreen="" loading="lazy" title="Gillco Group Location" /></section>
    </div >
  );
};
